<template>
    <div class="main-footer">{{ desc }}</div>
</template>

<script>
export default {
    name: 'MainFooter',
    computed: {
        desc() {
            return this.$store.state.desk.powerby;
        }
    }
};
</script>

<style scoped>
.main-footer {
    display: inline-block;
    position: fixed;
    bottom: 64px;
    left: 50vw;
    transform: translateX(-50%);
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 2.5px;
}
</style>
